import React from 'react';

import { Screen } from '@confluence/screen';
import { Onboarding } from '@confluence/onboarding';

export const OnboardingRoute = () => (
	<Screen screenEvent={{ name: 'onboardingContainerScreen' }}>
		<Onboarding />
	</Screen>
);
